import React from "react";
import { getUrlParam } from "./scroll-card";
import get from "lodash/get";
import canUseDOM from './can-use-dom';

export function scrollInViewCard(props = {}, card, options={
        behavior: "smooth",
        block: "start"
      }) {
  const elementId = get(props,['card','id'], 0);
  if(canUseDOM && elementId === getUrlParam(window.location.href, "cardId")) {
    card.scrollIntoView(options);
  }
}